/** पूरी साइट की प्रतिलिपि — देवनागरी (हेडर में HI चुनें)। कुंजियाँ englishContent.js जैसी ही रखें */
const hindiContent = {
  common: {
    brandAnchor: 'सीखें। कमाएँ। <br/>सुरक्षित रहें।',
    mail: 'humproecosystem@gmail.com',
    domain: 'humpro.in',
    rightsSuffix: 'HumPro. सर्वाधिकार सुरक्षित।',
    contactPhoneE164: '9263123137',
  },
  floatingContact: {
    groupLabel: 'त्वरित संपर्क',
    call: 'HumPro को कॉल करें',
    whatsapp: 'WhatsApp पर लिखें',
    email: 'HumPro को ईमेल करें',
    callViaContact: 'कॉल के लिए संपर्क पृष्ठ खोलें',
    whatsappViaContact: 'WhatsApp के लिए संपर्क पृष्ठ खोलें',
  },
  header: {
    nav: {
      home: 'मुख पृष्ठ',
      about: 'हमारे बारे में',
      courses: 'पाठ्यक्रम',
      consultancy: 'परामर्श / बीमा',
      careers: 'करियर / नौकरी',
      contact: 'संपर्क करें',
    },
    brandAria: 'HumPro — मुख पृष्ठ',
    menuOpen: 'मेनू खोलें',
    menuClose: 'मेनू बंद करें',
    langGroupAria: 'साइट भाषा चुनें, अंग्रेज़ी या हिंदी',
    langHiTitle: 'हिंदी, पूरी साइट देवनागरी में',
    langEnHidden: 'अंग्रेज़ी',
    langHiHidden: 'हिंदी',
  },
  footer: {
    tagline: 'सीखें। कमाएँ। सुरक्षित रहें। — हर भारतीय परिवार के लिए शिक्षा, आमदनी और सुरक्षा।',
    navSite: 'साइट',
    navMore: 'और',
    navHome: 'मुख पृष्ठ',
    navAbout: 'परिचय',
    navCourses: 'पाठ्यक्रम',
    navConsultancy: 'परामर्श',
    navCareers: 'करियर',
    navContact: 'संपर्क',
    privacy: 'गोपनीयता',
    terms: 'नियम',
    linkedin: 'LinkedIn',
    youtube: 'YouTube',
    instagram: 'Instagram',
    facebook: 'Facebook',
  },
  home: {
    hero: {
      eyebrowHi: 'शिक्षा · सुरक्षा · सशक्तिकरण',
      eyebrowEn: 'Education · Protection · Empowerment',
      title: 'आपके परिवार के हक़ में बिखरे वादों से ज़्यादा है।',
      titleLine2: 'HumPro सब कुछ एक ही जगह देता है।',
      lead:
        'ज़्यादातर भारतीय परिवार शिक्षा, काम और बीमा के लिए तीन अलग विशेषज्ञों के पीछे भागते हैं — फिर भी पीछे रह जाते हैं। HumPro तीनों को एक साथ, आपकी घर की भाषा में और आपकी मेहनत का सम्मान करने वाली कीमत पर लाता है।',
      playAria: 'HumPro ऐप डाउनलोड करें',
      playSmall: 'डाउनलोड',
      playStrong: 'HumPro ऐप',
      exploreCourses: 'पाठ्यक्रम देखें',
      talkToAdvisor: 'HumPro सलाहकार से बात करें — मुफ़्त',
      photoAlt: 'HumPro — शिक्षा, काम और परिवार की सुरक्षा के लिए सहयोग।',
      pillTextHi: 'बिहार से शुरू। भारत के लिए।',
      pillTextEn: 'Started in Bihar. Built for every Indian family.',
    },
    focusHiddenTitle: 'HumPro परिवारों की कैसे मदद करता है',
    focusCards: {
      courses: {
        title: 'कौशल जो असली दरवाज़े खोलें',
        body:
          'CBSE व बिहार बोर्ड सहायता, अंग्रेज़ी संवाद और कौशल प्रशिक्षण — ऐसे मार्गदर्शक जो सफलता आपकी वृद्धि से मापते हैं, कमीशन से नहीं।',
        linkLabel: 'पाठ्यक्रम देखें',
      },
      careers: {
        title: 'काम जो आपकी मेहनत की कीमत दे',
        body:
          'बिहार और 7 प्रमुख शहरों में सत्यापित भूमिकाएँ। कोई दलाल नहीं। कोई नकली लिस्टिंग नहीं। बस ईमानदार काम उन लोगों के लिए जो आगे आने को तैयार हैं।',
        linkLabel: 'करियर देखें',
      },
      consultancy: {
        title: 'बीमा परिवार की तरह समझाया — छोटे अक्षरों में नहीं',
        body:
          'टर्म, स्वास्थ्य और दुर्घटना कवर — सादी हिंदी और अंग्रेज़ी में तब तक जब तक आप समझ न जाएँ कि क्या खरीद रहे हैं और यह परिवार को क्यों सुरक्षित करता है।',
        linkLabel: 'परामर्श देखें',
      },
    },
    why: {
      placeholderAria: 'छवि स्थान — अंतिम आकार 560 × 700 पिक्सेल',
      placeholderKicker: 'छवि क्षेत्र',
      placeholderDims: '560 × 700 px',
      placeholderNote: 'वायरफ़्रेम — बाद में बदलें',
      title: 'तीन समस्याएँ। एक घर। कोई भागदौड़ नहीं।',
      lead: '',
      reasons: [
        'हर रुपया, हर पाठ, हर पॉलिसी — प्रतिबद्धता से पहले साफ़ समझाया जाता है।',
        'हम हिंदी बोलते हैं। आपकी हक़ीक़त समझते हैं। बातचीत जैसा मार्गदर्शन, बिक्री भाषण नहीं।',
        'आपके परिवार का बीमा — आप चुनें, हम समझाएँ, कभी थोपें नहीं।',
        'सबसे ज़्यादा मेहनत करने वाले परिवारों के लिए बना — जिन्हें सबसे कम मदद मिलती है। यहाँ बदलाव शुरू होता है।',
        'सब कुछ के लिए एक भरोसेमंद टीम — ताकि आप भागना बंद करें और बढ़ना शुरू करें।',
      ],
      closing: '“आज समझ। कल बदलाव। हमेशा साथ।” · “आज समझ, कल बदलाव, हमेशा साथ।”',
      photoAlt: 'शिक्षा, रोज़गार और सुरक्षा के लिए HumPro चुनने वाले परिवार।',
    },
    testimonial: {
      kicker: 'एक HumPro परिवार की कहानी',
      title: 'एक परिवार। तीन मुश्किलें। एक HumPro कॉल।',
      quote:
        'पहले हम ट्यूशन, नौकरी एजेंट और बीमा ऑफिस के बीच भागते थे — फिर भी अटके रहते थे। HumPro ने बेटे की अंग्रेज़ी कोर्स समझाई, पति को पटना में सत्यापित साइट काम दिलाया, और स्वास्थ्य कवर हिंदी में समझाया। पहली बार किसी ने बिक्री के बाद भी साथ दिया। तब समझा — HumPro सिर्फ़ एक सेवा नहीं, एक साथी है।',
      author: 'सुनीता और रवि के.',
      location: 'पटना, बिहार',
      detail: 'HumPro उपयोगकर्ता · पाठ्यक्रम + नौकरी + बीमा',
      photoAlt: 'HumPro के साथ सीख, काम और सुरक्षा पाने वाला परिवार।',
    },
    founder: {
      kicker: 'संस्थापक का संदेश',
      title: 'हर परिवार पर विश्वास',
      quote:
        '“जो आप सोचते हैं, वही आप बन जाते हैं। HumPro इसी सच पर टिका है — हर परिवार को सम्मानजनक भविष्य का हक़ है।”',
      cite: 'गोलाम नूरानी, संस्थापक, HumPro Ecosystem',
    },
    company: {
      kicker: 'HumPro के बारे में',
      title: 'एक घर। तीन वादे। शिक्षा, आमदनी और सुरक्षा।',
      lead:
        'ज़्यादातर परिवार तीन अलग विशेषज्ञों के पीछे भागते हैं और फिर भी पीछे रह जाते हैं। HumPro सब कुछ एक छत के नीचे — उसी भाषा में जो आप घर में बोलते हैं।',
      chipsAria: 'HumPro के मुख्य कार्यक्षेत्र',
      chips: ['शिक्षा सहयोग', 'नौकरी और साझेदारी', 'बीमा परामर्श'],
      foot: 'सीखें। कमाएँ। सुरक्षित रहें। — बिहार और भारत के हर घर के लिए हमारा आधार।',
      cta: 'HumPro के बारे में और जानें',
      photoAlt: 'HumPro समुदाय — भारतीय परिवारों के लिए एक इकोसिस्टम।',
    },
  },
  about: {
    heroEyebrow: 'HumPro Ecosystem',
    heroTitle: 'HumPro के बारे में',
    heroLead:
      'बिहार में बना। भारत के लिए बना। क्योंकि हर परिवार वही औज़ार पाने का हक़ रखता है जो सुविधा-प्राप्त लोग मानते हैं।',
    heroPhotoAlt: 'बिहार और भारत में HumPro के साथ मज़बूत भविष्य बनाते समुदाय।',
    standTitle: 'हम किन सिद्धांतों पर चलते हैं',
    standStart: 'HumPro परिवारों को बेहतर जीवन की ओर ले जाता है',
    standEdu: 'शिक्षा',
    standEduNote: '(जो अवसर खोलती है),',
    standWork: 'सार्थक काम',
    standWorkNote: '(नौकरी और भरोसेमंद साझेदारी), और',
    standProtection: 'सुरक्षा',
    standEnd:
      'सुरक्षा (स्वास्थ्य, टर्म व दुर्घटना बीमा—सीधी भाषा में, ताकि आप समझदारी से फैसला लें, न कि दबाव में आकर) को एक साथ जोड़कर।',
    splitPlaceholderAria: 'HumPro परिचय — छवि स्थान, अंतिम आकार 560 × 700 px',
    splitTitle: 'परिवार हमसे क्या उम्मीद रख सकते हैं',
    splitLead:
      'हम आपको तीन अलग चीज़ें नहीं बेचते। हम तीनों में साथ चलते हैं — क्योंकि परिवार की ज़िंदगी अलग-अलग विभागों में नहीं आती।',
    splitPhotoAlt: 'शिक्षा, काम और सुरक्षा के लिए एक जगह HumPro पर भरोसा करते परिवार।',
    splitBullets: [
      'हम स्पष्ट रूप से बताते हैं कि खर्च कितना है, मार्गदर्शन कौन करेगा, और आगे की प्रक्रिया क्या होगी—ताकि आप समय या बचत निवेश करने से पहले सही निर्णय ले सकें।',
      'शिक्षा, काम और बीमा एक ही तंत्र में जुड़े रहते हैं, ताकि आपको तीन अलग-अलग और आपस में असंबंधित विकल्पों के बीच न भटकना पड़े।',
      'स्कूल की पढ़ाई, गाँव की कनेक्टिविटी, और सीमित बजट—सब कुछ असली घरों की जरूरतों के अनुसार।',
      'आपको हमेशा ईमेल के जरिए आगे बात करने का रास्ता मिलता है—जहाँ असली लोग आपके संदेश को पढ़ते हैं।',
    ],
    splitClosing:
      '“विश्वास पहले, दिखावा नहीं।” · “हम भरोसा धीरे-धीरे कमाना पसंद करते हैं, सुंदर पिच से जल्दी खोना नहीं।”',
    founderLabel: 'संस्थापक',
    founderName: 'गोलाम नूरानी',
    founderRole: 'संस्थापक और CEO, HumPro Ecosystem · बिहार',
    founderQuote:
      '“मैंने बिहार में देखा है — एक बाप जो अपने बच्चे के लिए स्कूल ढूँढता है, काम ढूँढता है, बीमा ढूँढता है। तीन अलग दुनियाओं में भागता है, अकेला। HumPro उसी के लिए बना है।”',
    founderCite: '— गोलाम नूरानी, संस्थापक',
    founderBio:
      'गोलाम ने HumPro बोर्डरूम से नहीं, बल्कि अपने समुदाय की रोज़ की समस्या से शुरू किया। बिहार में पले-बढ़े, उन्होंने मेहनती परिवारों को पीछे रहते देखा — महत्वाकांक्षा की कमी से नहीं, बल्कि सही औज़ार, अपनी भाषा में और भरोसेमंद कीमत पर न मिलने से। HumPro उनका जवाब है — एक इकोसिस्टम, एक भरोसेमंद नाम, हर भारतीय घर के लिए जो बिखरे वादों से बेहतर का हक़ रखता है।',
    founderClosing: '“एक इंसान की सोच। हज़ारों परिवारों का सपना।”',
    ctaTitle: 'जुड़ना चाहेंगे?',
    ctaText:
      'संपर्क पृष्ठ पर नाम, नंबर, विषय और संदेश भेजें — असली इंसान पढ़ता है।',
    ctaHome: 'मुख पृष्ठ पर लौटें',
    ctaContact: 'संपर्क पृष्ठ',
  },
  coursesPage: {
    heroEyebrow: 'पाठ्यक्रम',
    heroTitle: 'असली कौशल। असली शिक्षक। आपकी मेहनत का सम्मान करने वाली कीमतें।',
    heroLead:
      'न बढ़ाया सिलेबस, न नकली जल्दबाज़ी। बस वे कोर्स जो आपके बच्चे, परिवार और भविष्य को चाहिए — ऐसे लोग जो सच में आते हैं।',
    heroPhotoAlt: 'HumPro मार्गदर्शकों के साथ व्यावहारिक कौशल सीखते छात्र।',
    bullets: [
      'CBSE व बिहार बोर्ड अनुकूल सहायता — रोज़मर्रा की भाषा में।',
      'होम ट्यूशन और अंग्रेज़ी — बच्चे के स्तर और समय के हिसाब से।',
      'नीचे की सूची से पाठ्यक्रम जोड़ें या बदलें — आसान।',
    ],
    backHome: '← मुख पृष्ठ',
    catalogTitle: 'हम क्या देते हैं',
    enquireLink: 'इस पाठ्यक्रम के बारे में पूछें',
    items: [
      {
        course_id: 'C001',
        course_title: 'अंग्रेज़ी कम्युनिकेशन कक्षा',
        course_description:
          'बोलचाल की अंग्रेज़ी, दैनिक संवाद, व्याकरण की स्पष्टता और इंटरव्यू कम्युनिकेशन को व्यावहारिक अभ्यास से मजबूत किया जाता है।',
        icon: 'english_icon.png',
      },
      {
        course_id: 'C002',
        course_title: 'होम ट्यूशन',
        course_description:
          'सभी विषयों में घर पर अनुकूलित ट्यूशन — छात्र की ज़रूरत के अनुसार।',
        icon: 'home_tuition_icon.png',
      },
      {
        course_id: 'C003',
        course_title: 'स्किल डेवलपमेंट ट्रेनिंग',
        course_description:
          'ट्यूटरिंग और ट्यूटर स्किल्स के साथ मेहंदी स्किल्स ट्रेनिंग, ताकि सीखने के साथ आत्मरोज़गार और आय बढ़ाने के अवसर मिलें।',
        icon: 'home_tuition_icon.png',
      },
    ],
  },
  careersPage: {
    heroEyebrow: 'करियर / नौकरी',
    heroTitle: 'काम ढूँढो। काम लगाओ। आमदनी बढ़ाओ।',
    heroLead:
      'सत्यापित भूमिकाएँ। कोई दलाल नहीं। कोई झूठा वादा नहीं। गाँव हो या मेट्रो — सम्मान से काम चाहिए तो HumPro आपके साथ ढूँढता है।',
    heroPhotoAlt: 'HumPro के ज़रिए सत्यापित काम पाने वाले श्रमिक और नौकरी चाहने वाले।',
    heroTrust: '“आपका भरोसा और विश्वास ही हमारी पहचान है।”',
    contactNow: 'अभी संपर्क करें',
    heroCtaNote:
      'संपर्क पृष्ठ खुलेगा — विषय “Jobs / careers” पहले से चुना। अपना हुनर, शहर और उपलब्धता लिखें।',
    citiesTitle: 'जिन शहरों में हम सक्रिय हैं',
    citiesLead:
      '“चाहे गाँव हो या शहर…” · बिहार की जड़ों से भारत के सबसे बड़े शहरों तक — आपका काम यहाँ मिलता है।',
    cities: ['पटना', 'नोएडा', 'दिल्ली', 'हैदराबाद', 'पुणे', 'अहमदाबाद', 'सूरत', 'मुंबई'],
    offersTitle: 'हम क्या देते हैं',
    offerings: [
      {
        id: 'manpower',
        title: 'निर्माण व उद्योग के लिए मानव बल',
        body:
          'सिविल ठेकेदारों और साइटों के लिए सरिया/शटरिंग काम की भरोसेमंद टीमें—जो सुरक्षा और गति को समझती हैं; बेतरतीब दिहाड़ी भागदौड़ नहीं।',
      },
      {
        id: 'listings',
        title: 'सत्यापित नौकरी मार्ग',
        body:
          'साइटों के अलावा: सरकारी, निजी, NGO और निर्माण क्षेत्र में सत्यापित खुलें — नकली सूची या “गारंटी” के लिए दलालों को पैसा नहीं।',
      },
      {
        id: 'partner',
        title: 'HumPro साझेदार व फ्रीलांस',
        body:
          'अपने क्षेत्र में HumPro के साथ अंशकालिक कमाई — पाठ्यक्रम साझा करें, बीमा मार्गदर्शन में मदद, कमीशन। डिजिटल कौशल? ग्राहकों से जुड़ें, घर से काम।',
      },
    ],
    specialTitle: 'मेहनती लोगों के लिए विशेष सहयोग',
    specialText:
      'जहाँ कार्यक्रम अनुमति दे, HumPro मुफ़्त शिक्षा, मुफ़्त बीमा परिचय, और मुफ़्त सुरक्षा मार्गदर्शन की दिशा दिखाता है — कमाते समय घर सुरक्षित रहे। नियम व शर्तें लागू; कुछ लाभों के लिए पंजीकरण ज़रूरी हो सकता है।',
  },
  consultancyPage: {
    heroEyebrow: 'परामर्श',
    heroTitle: 'परिवार की सुरक्षा — सीधी बात, कोई उलझन नहीं।',
    heroLead:
      'बीमा जाल जैसा नहीं लगना चाहिए। हम टर्म, स्वास्थ्य और दुर्घटना कवर सादी भाषा में समझाते हैं — ताकि आप परिवार की सुरक्षा करें, सिर्फ़ कागज़ पर हस्ताक्षर नहीं।',
    heroPhotoAlt: 'HumPro सलाहकारों से स्पष्ट बीमा मार्गदर्शन पाते परिवार।',
    contactNow: 'अभी संपर्क करें',
    heroCtaNote:
      'संपर्क पृष्ठ — विषय बीमा/परामर्श चुना। मुफ़्त परिचय कॉल माँग सकते हैं।',
    plansTitle: 'तीन योजनाएँ जो सच में मायने रखती हैं — आप चुनें, हम समझाएँ, कभी थोपें नहीं।',
    plansLead:
      'कौन सा प्लान आपके लिए सही है? हम बिना पॉलिसी थोपे, आपकी ज़रूरतों के अनुसार समझाकर बताते हैं।',
    plans: [
      {
        id: 'term',
        title: 'टर्म बीमा',
        body:
          'परिवार की सुरक्षा अब आसान—समझदार प्रीमियम में बेहतर कवर। कब शुरुआत करें, कितनी सुरक्षा चाहिए और किन बातों को अनदेखा करें—सब स्पष्ट।',
      },
      {
        id: 'health',
        title: 'स्वास्थ्य बीमा',
        body:
          'अस्पताल का खर्च आपकी बचत से नहीं, पॉलिसी से पूरा हो। नेटवर्क, कमरे की सीमा, सह-भुगतान और अतिरिक्त सुविधाएँ—सब समझाकर ऐसा प्लान चुनने में मदद जो बीमारी के समय सच में काम आए।',
      },
      {
        id: 'accident',
        title: 'दुर्घटना कवर',
        body:
          'ज़िंदगी अनिश्चित है। एक छोटी पॉलिसी आय और आपात स्थितियों में सहारा देती है—सादी भाषा में समझाया गया, बिना ज़रूरत से ज़्यादा चीज़ें जोड़े।',
      },
    ],
    stepsTitle: 'कैसे काम करता है — तीन सरल कदम',
    steps: [
      {
        n: '1',
        title: 'बात करो',
        body: 'WhatsApp पर संदेश या संपर्क पृष्ठ — परामर्श मुफ़्त; “पंजीकरण शुल्क” का जाल नहीं।',
      },
      {
        n: '2',
        title: 'समझो',
        body: 'पहले स्थिति सुनते हैं, फिर टर्म, स्वास्थ्य, दुर्घटना या मिश्रण — जो फिट बैठे।',
      },
      {
        n: '3',
        title: 'सुरक्षित करो',
        body: 'स्पष्टता से पॉलिसी चुनें। तैयार हों तो आय और बजट पर MasterClass.',
      },
    ],
    masterLineBefore: 'सिर्फ़ बीमा नहीं —',
    masterLineStrong: 'HumPro MasterClass',
    masterLineAfter:
      'में आय बढ़ाने, बजट संभालने और छोटे व्यवसाय की बुनियाद सिखाई जाती है — कमाई के साथ सुरक्षा।',
    quoteBody:
      '“आज का एक सही फैसला कल की हज़ार परेशानियों से बचाता है। परिवार के लिए सोचना — यही असली सशक्तिकरण है।”',
    quoteFooter: '— HumPro परामर्श दल',
  },
  contactPage: {
    heroEyebrow: 'संपर्क',
    heroPhotoAlt: 'HumPro MasterClass सत्र में एक साथ सीखते समुदाय के सदस्य।',
    heroTitle: 'जुड़ें हमसे — हम यहाँ हैं',
    heroLead:
      'कोई सवाल है? आपका संदेश असली इंसान पढ़ता है—सीधा, जल्दी और ध्यान से। यहाँ सात दिन तक टेम्पलेट वाले जवाब का इंतज़ार नहीं करना पड़ता।',
    heroTagline: '“आपका भरोसा और विश्वास ही हमारी पहचान है।”',
    formTitle: 'संदेश भेजें',
    formIntroBefore:
      'नाम, फोन / WhatsApp, विषय और संदेश भरें। अगर सीधा सबमिट न हो पाए, तो “ईमेल से भेजें” विकल्प मिल जाएगा:',
    asideTitle: 'अन्य तरीके',
    asideWhatsappStrong: 'WhatsApp',
    asideWhatsapp: '— छोटे सवालों के लिए सबसे तेज़ (व्यवसाय नंबर जोड़ें जब तैयार हों)।',
    asideEmailStrong: 'ईमेल',
    asideEmailAfter: '— लंबी बात, साझेदारी या मीडिया के लिए।',
    asideAppStrong: 'ऐप',
    asideApp: '— पाठ्यक्रम, अपडेट और सहायता एक जगह (स्टोर लिंक जल्द)।',
    asideFoot: '“अकेले मत जाओ — HumPro समुदाय में आओ। यहाँ सबका स्वागत है।”',
  },
  contact: {
    form: {
      purposeOptions: [
        { value: 'job', label: 'नौकरी / करियर' },
        { value: 'consultancy', label: 'बीमा / परामर्श' },
        { value: 'courses', label: 'पाठ्यक्रम / ट्यूशन' },
        { value: 'admission', label: 'प्रवेश' },
        { value: 'partnership', label: 'साझेदारी' },
        { value: 'other', label: 'अन्य' },
      ],
      name: 'नाम',
      namePh: 'आपका नाम',
      phone: 'फोन / WhatsApp',
      phonePh: 'उदा. +91 98765 43210',
      topic: 'विषय',
      topicPlaceholder: 'विषय चुनें',
      message: 'संदेश',
      messagePh: 'हम कैसे मदद करें?',
      submit: 'संदेश भेजें',
      submitting: 'भेजा जा रहा है…',
      sent: 'धन्यवाद — आपका संदेश सहेज लिया गया। हम जल्द संपर्क करेंगे।',
      fallbackEmail: 'ईमेल ऐप खोल दिया है ताकि आप हमारी टीम को प्रति भेज सकें।',
      sheetFailed:
        'अभी संदेश सबमिट नहीं हो सका। आप ईमेल से भेज सकते हैं:',
      emailInstead: 'ईमेल से भेजें',
      hintSheetBefore: 'आपका संदेश सीधे सबमिट होता है। यदि नेटवर्क से न हो सके तो ईमेल ऐप खुलकर ',
      hintSheetAfter: ' पर भेजने का विकल्प मिलता है। हम जल्द जवाब देंगे।',
      hintEmailBefore: 'ईमेल ऐप खुलेगा — प्रेषित करें ',
      hintEmailAfter: '। हम जल्द जवाब देंगे — लंबी टिकट कतार नहीं।',
    },
    popup: {
      title: 'HumPro से संपर्क',
      hintBefore: 'पूरा फ़ॉर्म और विकल्पों के लिए देखें ',
      contactPageLink: 'संपर्क पृष्ठ',
      hintAfter: '। त्वरित भेज सीधे सबमिट करता है; न हो सके तो ईमेल ऐप खुलता है।',
      closeThanks: 'बंद करें',
      name: 'नाम',
      phone: 'संपर्क नंबर',
      topic: 'विषय',
      message: 'संदेश',
      messagePh: 'हम कैसे मदद करें?',
      cancel: 'रद्द करें',
      submit: 'जमा करें',
    },
  },
  upcoming: {
    status: 'HumPro ऐप लाइव है',
    title: 'HumPro का अपना ऐप अब उपलब्ध है',
    subtitle:
      'सीखते रहें, बढ़ते रहें। पाठ्यक्रम, करियर सहायता और बीमा मार्गदर्शन — सब कुछ एक HumPro ऐप में।',
    playAria: 'HumPro ऐप डाउनलोड करें',
    playSmall: 'डाउनलोड',
    playStrong: 'HumPro ऐप',
    back: '← मुख पृष्ठ',
  },
  privacyPage: {
    title: 'गोपनीयता नीति',
    updated: 'अंतिम अपडेट: मई 2026',
    intro:
      'HumPro आपकी गोपनीयता का सम्मान करता है। यहाँ बताया गया है कि हम कौन-सी जानकारी लेते हैं और उसका उपयोग कैसे करते हैं।',
    sections: [
      {
        heading: 'हम कौन-सी जानकारी लेते हैं',
        body:
          'संपर्क फ़ॉर्म में नाम, फोन नंबर, विषय और संदेश लिया जा सकता है। यदि आप ईमेल करते हैं, तो ईमेल में दी गई जानकारी हमें मिलती है।',
      },
      {
        heading: 'जानकारी का उपयोग',
        body:
          'जानकारी का उपयोग केवल जवाब देने, सहायता देने और सेवाओं को बेहतर बनाने के लिए किया जाता है। हम आपकी जानकारी बेचते नहीं हैं।',
      },
      {
        heading: 'जानकारी साझा करना',
        body:
          'वेबसाइट चलाने के लिए भरोसेमंद तकनीकी सेवाओं का उपयोग हो सकता है। उन्हें केवल ज़रूरी सीमा तक ही जानकारी मिलती है।',
      },
      {
        heading: 'डेटा सुरक्षा',
        body:
          'हम आपकी जानकारी सुरक्षित रखने के लिए उचित तकनीकी और प्रशासनिक कदम अपनाते हैं।',
      },
      {
        heading: 'आपके अधिकार',
        body:
          'आप अपनी जानकारी में सुधार या हटाने का अनुरोध humproecosystem@gmail.com पर भेज सकते हैं।',
      },
    ],
  },
  termsPage: {
    title: 'नियम और शर्तें',
    updated: 'अंतिम अपडेट: मई 2026',
    intro:
      'ये नियम HumPro वेबसाइट के उपयोग पर लागू होते हैं। साइट का उपयोग करके आप इन नियमों से सहमत होते हैं।',
    sections: [
      {
        heading: 'सामग्री का उपयोग',
        body:
          'साइट की सामग्री शिक्षा, करियर और परामर्श सेवाओं की सामान्य जानकारी के लिए है। बिना अनुमति कॉपी या पुन: उपयोग न करें।',
      },
      {
        heading: 'सेवा जानकारी',
        body:
          'हम जानकारी सही रखने का प्रयास करते हैं, पर कोर्स, सेवाएँ और योजनाएँ समय के साथ बदल सकती हैं।',
      },
      {
        heading: 'उपयोगकर्ता की जिम्मेदारी',
        body:
          'कृपया फ़ॉर्म में सही जानकारी दें और वेबसाइट का उपयोग किसी गलत, भ्रामक या गैरकानूनी काम के लिए न करें।',
      },
      {
        heading: 'बाहरी लिंक',
        body:
          'साइट पर ऐप स्टोर या सोशल प्लेटफ़ॉर्म के लिंक हो सकते हैं। तीसरे पक्ष की वेबसाइट सामग्री के लिए हम जिम्मेदार नहीं हैं।',
      },
      {
        heading: 'संपर्क',
        body:
          'इन नियमों से जुड़े सवालों के लिए humproecosystem@gmail.com पर संपर्क करें।',
      },
    ],
  },
};

export default hindiContent;
